<div class="flex flex-column justify-content-between custom-component-container">

    <div class="flex h-full relative">
        <!-- desktop device steps begin -->
        <div class="hidden md:block pb-5 w-3 min-h-full stepper-left-side bg-gray-100 fixed text-primary">
            <div class="flex flex-column h-12rem">
                <span class="text-3xl font-bold px-6 pt-5 pb-3">
                    {{ 'sipo.sign' | translate }}
                </span>
                <span class="text-3xl font-medium px-6 py-2">
                    {{ 'sipo.step' | translate }} {{ activeIndex + 1 }}
                </span>
                <span class="text-lg px-6 py-2">
                    {{ activeIndexDescription }}
                </span>
            </div>
            <p-steps [model]="items" [readonly]="false" [activeIndex]="activeIndex" styleClass="text-primary-500"
                     (activeIndexChange)="onActiveIndexChange($event)"/>
        </div>
        <!-- desktop device steps end -->
        <!-- mobile device steps begin -->
        <p-steps class="fixed top-0 left-0 z-5 bg-gray-100 shadow-1 md:hidden py-4" [model]="items" [readonly]="false"
                 [activeIndex]="activeIndex" styleClass="'bg-red-500'"
                 (activeIndexChange)="onActiveIndexChange($event)"/>
        <!-- mobile device steps end -->
        <div
            class="absolute right-0 flex flex-column justify-content-between align-items-center w-full md:w-9 p-4 custom-content-container mt-5 md:mt-0"
            [ngClass]="activeIndex != 2 || isYaxisScrollAvailable ? 'overflow-y-scroll': ''">

            <!-- actice index 0 begin -->
            <ng-template [ngIf]="activeIndex === 0">
                <app-upload-document
                    (emitFiles)="receiveFiles($event)"
                    [isSelectedFileLoading]="isSelectedFileLoading"
                    [isCloseTriggered]="isCloseTriggered">
                </app-upload-document>
            </ng-template>
            <!-- actice index 0 end -->

            <!-- actice index 1 begin -->
            <!--            <ng-template [ngIf]="activeIndex === 1">-->
            <!--                <app-signer-options [signerOptionForm]="formGroup"-->
            <!--                                    (formEmitter)="receiveSignerOption($event)"></app-signer-options>-->
            <!--            </ng-template>-->
            <!-- actice index 1 end -->

            <!-- actice index " begin -->
            <ng-template [ngIf]="activeIndex === 1">
                <app-add-signers
                    [signersForm]="formGroup"
                    [isCloseTriggered]="isCloseTriggered"
                    [userSubscription]="userSubscription"
                    (signersEmitter)="receiveSigners($event)"></app-add-signers>
            </ng-template>
            <!-- actice index " end -->

            <!-- actice index 2 begin -->
            <ng-template [ngIf]="activeIndex === 2">
                <app-drag-drop-scroll
                    [pdfId]="pdfId"
                    [processId]="processId"
                    [signerModel]="signerModel"
                    [addedPeople]="signerEmailShared"
                    [isCloseTriggered]="isCloseTriggered"
                    (outPdfSize)="getPdfSize($event)"
                    (outSignPosition)="getSignPositions($event)"
                    (outStepsAvailability)="receiveStepAvailability($event)"
                    (outIsLoading)="receiveIsLoading($event)"
                    [pdfFileUploadingProcessTrack]="pdfFileUploadingProcessTrack"
                    class="w-full">
                </app-drag-drop-scroll>
            </ng-template>
            <!-- actice index 2 end -->

            <!-- actice index 3 begin -->
            <ng-template [ngIf]="activeIndex === 3">
                <app-comments-and-observers
                    class="w-full"
                    [formGroup]="formGroup"
                    [files]="observerAndCommentsComponentFileArray"
                    [isCloseTriggered]="isCloseTriggered"
                    (outFiles)="receiveAdditionalFiles($event)"
                    (outFormGroup)="getObserverAndComments($event)">
                </app-comments-and-observers>
            </ng-template>
            <!-- actice index 3 end -->

            <!-- actice index 4 begin -->
            <ng-template [ngIf]="activeIndex === 4">

                <a *ngIf="signLink" href="{{signLink}}" target="">{{ signLink }}</a>
                <app-final-preview
                    class="w-full"
                    [signerData]="signerModel"
                    [formGroup]="formGroup"
                    *ngIf="!toastInfo.isOpen"
                ></app-final-preview>

                <app-sign-process-state class="w-full" [toastInfo]="toastInfo" [selfSignUrl]="selfSignUrl"
                                        *ngIf="toastInfo.isOpen"></app-sign-process-state>
            </ng-template>
            <!-- actice index 4 end -->

            <!-- cancel sign confirmation modal begin -->
<!--            <app-cancel-sign-confirmation-modal>-->
<!--            </app-cancel-sign-confirmation-modal>-->
            <!-- cancel sign confirmation modal end -->

            <div class="flex justify-content-between w-9 fixed" style="bottom: 1rem;">
                <div class="w-11rem flex justify-content-end" style="text-align: left;">
                    <p-button styleClass="w-10rem" [label]="'sipo.cancel-sign' | translate" severity="danger"
                              icon="pi pi-times" (click)="closeSign(false)"
                              *ngIf="(!toastInfo.isOpen) || (toastInfo.isOpen && activeIndex != 4) || (toastInfo.isOpen && toastInfo.state === 'error')"/>
                </div>
                <div class="w-11rem flex" style="text-align: right;">
                    <p-button styleClass="w-10rem" [label]="'sipo.next' | translate" icon="pi pi-check"
                              [disabled]="getDisabledPropertyOfNextButton()" (click)="save()"
                              *ngIf="activeIndex != 4"/>
                    <p-button styleClass="w-10rem" [label]="'sipo.submit' | translate" icon="pi pi-check"
                              (click)="save()"
                              *ngIf="(activeIndex === 4 && !toastInfo.isOpen) || (activeIndex === 4 && toastInfo.state === 'error')"/>
                    <p-button styleClass="w-10rem" [label]="'sipo.close' | translate" icon="pi pi-check"
                              (click)="closeSign(false)"
                              *ngIf="toastInfo.isOpen && toastInfo.state === 'success'  && activeIndex === 4"/>
                </div>
            </div>
        </div>
    </div>
</div>
